module.exports = __webpack_public_path__ + "img/role2.d3f2a749.png";